import React, { useState } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { FiInfo, FiAlertTriangle } from 'react-icons/fi';
import { BaseModal } from './shared/BaseModal';

const InfoIconButton = styled(motion.button)`
  background: none;
  border: none;
  color: #F59E0B;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  font-size: 20px;
  
  &:hover {
    background: rgba(245, 158, 11, 0.1);
    transform: scale(1.1);
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

const ModalHeader = styled.div`
  margin-bottom: 20px;
`;

const ModalTitle = styled.h3`
  color: #F59E0B;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
`;

const WarningContent = styled.div`
  background: rgba(245, 158, 11, 0.1);
  border: 1px solid #F59E0B;
  border-radius: 8px;
  padding: 16px;
  color: #F59E0B;
  font-size: 14px;
  line-height: 1.6;
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

const WarningIcon = styled.div`
  flex-shrink: 0;
  font-size: 20px;
  margin-top: 2px;
`;

const WarningText = styled.div`
  flex: 1;
`;

export const TimeAccuracyInfo = ({ timeAccuracy }) => {
  const [isOpen, setIsOpen] = useState(false);

  // Only show icon if there's an accuracy issue
  if (!timeAccuracy || (timeAccuracy.status !== 'inaccurate' && timeAccuracy.status !== 'warning' && timeAccuracy.status !== 'stale')) {
    return null;
  }

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return (
    <>
      <InfoIconButton
        onClick={handleOpen}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        aria-label="Time accuracy information"
      >
        <FiInfo />
      </InfoIconButton>

      <BaseModal
        isOpen={isOpen}
        onClose={handleClose}
        zIndex={1500}
        maxWidth="500px"
      >
        <ModalHeader>
          <ModalTitle>
            <FiAlertTriangle />
            Time Accuracy Warning
          </ModalTitle>
        </ModalHeader>

        <WarningContent>
          <WarningIcon>
            <FiAlertTriangle />
          </WarningIcon>
          <WarningText>
            {timeAccuracy.warning || 'Device time may not be synchronized with server time. This could affect the accuracy of visa expiration calculations.'}
          </WarningText>
        </WarningContent>
      </BaseModal>
    </>
  );
};

